<template>
    <div>
        <div v-for="(item, index) in items"
             class="item"
             :key="index"
        >
            <TotemCourseItemVertical :course="item.data" v-if="isCourse(item)" />
            <TotemCollectionItemVertical :collection="item.data"  v-if="isCollection(item)" />
            <TotemLearningPathItemVertical :learningPath="item.data"  v-if="isLearningPath(item)" />
        </div>
    </div>
</template>

<script>
    import { listingMixin } from 'components/searchable-listing/listings/listing-helper'
    export default {
        name: 'VerticalListing',
        mixins: [listingMixin]
    }
</script>

<style lang="scss" scoped>
.item {
    @include course_list_item_vertical;
}
</style>
